<template>

  <div>
    <CandidateHeader />
    <CandidateProfile />
  </div>

</template>

<script>
import CandidateHeader from './Header/CandidateHeader'
import CandidateProfile from './Profile/CandidateProfile'

export default {
  name: 'Candidate',
  components: {
    CandidateHeader,
    CandidateProfile
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/CandidateInfo.vue